import { GET_CC_LIST } from 'fixtures/actions'
import { SEARCH_CC } from 'fixtures/api'
import { getAllList } from 'services/cmsService'

const getCCsData = (keyword, pitId) => {
  return async dispatch => {
    let data = []

    dispatch({
      type: GET_CC_LIST,
      payload: {
        data,
        isLoading: true
      }
    })

    let newData = await getAllList(SEARCH_CC(keyword, pitId))
    if (newData && !('errors' in newData)) {
      let recent = await newData.recent.map(d => ({...d, section: 'recent'}))
      let search = await newData.search.map(d => ({...d, section: 'search'}))
      data = [...recent, ...search].slice(0,10)
    }

    dispatch({
      type: GET_CC_LIST,
      payload: {
        data,
        isLoading: false
      }
    })
  }
}

export { getCCsData }
